import React from 'react'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { type IconName } from '~/utils'

type ButtonAttribute<T extends string> = {
  icon?: IconName
  text?: string
  value: T
}

export type ToggleRadioButtonProps<T extends string> = {
  attribute: ButtonAttribute<T>
  disabled?: boolean
  selected?: boolean
  onChange?: (value: T) => void
}

export const ToggleRadioButton = <T extends string>({
  attribute: { icon, text = '', value },
  disabled,
  onChange,
  selected,
}: ToggleRadioButtonProps<T>) => {
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    onChange?.(value)
  }, [value, onChange])

  return (
    <StyledButton
      key={value}
      disabled={disabled}
      icon={icon}
      selected={selected}
      togglable={true}
      onClick={handleClick}
    >
      {text}
    </StyledButton>
  )
}
